import lodash from 'lodash';
import { EnumAPI } from '../../apis';
import { AjaxBasics } from '../../helpers';
import { ShareController } from '../system/share';
export class ShareLinkController extends ShareController {
  /**
   * 解析推广码
   */
  onAnalyze(entity) {
    return AjaxBasics.request({
      ...EnumAPI.content_live_recordV2,
      body: lodash.assign({}, entity, {
        shareTime: Date.now(),
        shareType: '3', //sharelink是3
      }),
    });
  }
}
